import React, { useEffect, useRef } from 'react';
import './TargetPicker.css';

// One product-type selection used by both manual entry points in the chat: the compact type
// button next to the input and the "more" (three dots) menu. Choosing a type only tells the
// planner what to build; it never starts a build or any paid packaging.
export const TARGET_OPTIONS = Object.freeze([
  { value: 'AUTO', label: 'אוטומטי', hint: 'המערכת מזהה מהבקשה' },
  { value: 'WEB', label: 'אתר / Web', hint: 'אתר או אפליקציית ווב' },
  { value: 'ANDROID', label: 'Android', hint: 'Preview קודם, אריזה אחר כך' },
  { value: 'IOS', label: 'iOS', hint: 'Preview קודם, אריזה אחר כך' },
  { value: 'DESKTOP', label: 'Desktop', hint: 'כולל Windows, Linux ו־macOS' },
  { value: 'BACKEND', label: 'Backend / API', hint: 'שרת ו־API' },
  { value: 'FULL_STACK', label: 'Full-Stack', hint: 'ממשק + שרת + מסד נתונים' }
]);

export function targetLabel(value) {
  return (TARGET_OPTIONS.find(option => option.value === value) || TARGET_OPTIONS[0]).label;
}

export default function TargetPicker({ value = 'AUTO', open, onToggle, onChange, disabled }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = event => { if (ref.current && !ref.current.contains(event.target)) onToggle(false); };
    const escape = event => { if (event.key === 'Escape') onToggle(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', escape);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', escape); };
  }, [open, onToggle]);

  return (
    <div className="target-picker" ref={ref}>
      <button type="button" className={`target-picker-chip${value !== 'AUTO' ? ' is-selected' : ''}`} onClick={() => onToggle(!open)} disabled={disabled} dir="auto"
        aria-haspopup="listbox" aria-expanded={open} aria-label={`סוג פרויקט: ${targetLabel(value)}`} title="סוג הפרויקט">
        {targetLabel(value)} ▾
      </button>
      {open && (
        <div className="target-picker-menu" role="listbox" aria-label="בחירת סוג פרויקט">
          {TARGET_OPTIONS.map(option => (
            <button key={option.value} type="button" role="option" aria-selected={value === option.value}
              className={value === option.value ? 'is-selected' : ''} dir="rtl"
              onClick={() => { onChange(option.value); onToggle(false); }}>
              <span>{option.label}</span>
              <small>{option.hint}</small>
              {option.value === 'DESKTOP' && <small className="target-picker-included">Windows · Linux · macOS</small>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
